import { render, staticRenderFns } from "./switchEatType.vue?vue&type=template&id=c277338e&scoped=true"
import script from "./switchEatType.vue?vue&type=script&lang=js"
export * from "./switchEatType.vue?vue&type=script&lang=js"
import style0 from "./switchEatType.vue?vue&type=style&index=0&id=c277338e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c277338e",
  null
  
)

export default component.exports